module.exports = __webpack_public_path__ + "static/img/qinchu_banner.72e2fe5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qinchu_banner.png
// module id = c+qb
// module chunks = 18